import { useStorageContext } from '@app/contexts/storage';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IModalErrorProps {}

export const ModalError: FunctionComponent<IModalErrorProps> = observer<FunctionComponent<IModalErrorProps>>(function () {
    const { globalStorage } = useStorageContext();

    let openModalError = globalStorage.openModalError;

    return (
        <Dialog open={openModalError} onClose={() => globalStorage.handleCloseModalError()} aria-describedby='alert-dialog-description'>
            <DialogContent>
                <DialogContentText id='alert-dialog-description'>Incorrect login or password</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        globalStorage.handleCloseModalError();
                    }}
                    size={'small'}
                    color='primary'>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
});
